module.exports = __webpack_public_path__ + "img/logo.adb2a0e4.png";